import axios from 'axios';
import { BASE_URL } from './api';

export async function getGeoLocations(token) {
    return axios({
        method: "get",
        url: `${BASE_URL}/geolocations`,
        headers: {
            'Authorization': `Token ${token}`
        }
    })
    .then(response => response.data)
    .catch(error => console.error(error))

}